import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";
import { lowerCase, upperFirst } from "lodash-es";
import type React from "react";
import { formatDate } from "../../../components/utils/HighlightNullAndOldDates.tsx";
import type { AssetPosition, Issue } from "../../../kubb";

interface AssetPositionIssuesPreviewProps {
  assetPosition: AssetPosition;
}

export function formatIssue(issue: Issue): string {
  switch (issue.category) {
    case "DATA_QUALITY.NO_ASSET":
      return `No asset is assigned from ${formatDate(issue.start_date_time, "L")}`;
    case "MANUAL.NOT_ADOPTED":
      return "Not Adopted";
    default:
      return `${upperFirst(lowerCase(issue.category.split(".")[1]))} since ${formatDate(issue.start_date_time, "L")}`;
  }
}

export default function AssetPositionIssuesPreview({
  assetPosition,
}: AssetPositionIssuesPreviewProps): React.ReactElement {
  return assetPosition.open_issues && assetPosition.open_issues.length > 0 ? (
    <div className="rounded-md bg-red-50 p-4" data-testid={"yes-issues"}>
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon aria-hidden="true" className="size-5 text-red-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium  text-red-800">
            {assetPosition.open_issues.length} open issue
            {assetPosition.open_issues.length > 1 ? "s" : ""}.
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>
              {assetPosition.open_issues.map(formatIssue).map((v) => (
                <span data-testid={"issues-list"} key={v}>
                  {v}
                </span>
              ))}
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="rounded-md bg-green-50 p-4" data-testid={"no-issues"}>
      <div className="flex">
        <div className="shrink-0">
          <CheckCircleIcon
            aria-hidden="true"
            className="size-5 text-green-400"
          />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-green-800">
            No open issues.
          </h3>
        </div>
      </div>
    </div>
  );
}
